'use strict';

var isArray = require('isarray');

// TODO: inline, semver-major

/** @type {(x: unknown) => x is object} */
module.exports = function isPlainObject(x) {
	return x && typeof x === 'object' && !isArray(x);
};



//////////////////
// WEBPACK FOOTER
// ./~/prop-types-exact/build/helpers/isPlainObject.js
// module id = 919
// module chunks = 2